var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{ref:"table",attrs:{"service":"Actions","initialize":_vm.initialize,"remove":_vm.remove,"update":_vm.update,"sanitize":_vm.sanitize,"headers":_vm.headers,"messages":_vm.messages,"draggend":_vm.onMove,"move":_vm.onMove,"silent":_vm.silent,"show-actions":_vm.actions,"draggable":_vm.draggable}})
}
var staticRenderFns = []

export { render, staticRenderFns }